// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db","contentWrapper":"modal_contentWrapper__zQKQX","closeWrapper":"modal_closeWrapper__j8Osw","ximage":"modal_ximage__xWmRa"};